module.exports = __webpack_public_path__ + "img/icon_employees_hk.47915839.png";